import React from 'react'

import ListPage from '../../genericCrud/ListPage'

const tableConfig = {
    id: 'id',
    properties: [
        { header: 'Navn', property: 'name' }       
    ],
    selectable: false
}

const crudConfig = {
    key: 'speciesOrder',
    createTitle: 'Opret orden',
    filter: [
        { label: 'Navn', property: 'name' }
    ],
    properties: [
        { label: 'Navn', property: 'name', type: 'string', required: true }
    ]
}

const ManageSpeciesOrder = props => {
    return (
        <ListPage pageTitle='Administrer Ordener' crudConfig={crudConfig} tableConfig={tableConfig} />
    )
}

export default ManageSpeciesOrder